import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => {}); }, [slug]);
  if (!p) return <div className="min-h-screen bg-navy-900 flex items-center justify-center text-slate-400 pt-20">Lädt…</div>;
  return (
    <div data-testid="blog-detail" className="bg-navy-900 min-h-screen">
      <Seo title={p.title} description={p.excerpt} path={`/ratgeber/${slug}`} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({ "@context": "https://schema.org", "@type": "Article", "headline": p.title, "description": p.excerpt, "articleSection": p.category, "author": { "@type": "Organization", "name": "VM-FFM.DE" } }) }} />
      <article className="pt-28 pb-24">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/ratgeber" className="text-slate-400 hover:text-gold-500 flex items-center gap-2 text-sm mb-8"><ArrowLeft size={16} /> Zurück zum Ratgeber</Link>
          {p.cover_image && <div className="rounded-md overflow-hidden aspect-video mb-8"><img src={p.cover_image} alt={p.title} className="w-full h-full object-cover" /></div>}
          <span className="text-xs uppercase tracking-wide text-gold-500 font-bold">{p.category}</span>
          <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-white leading-tight">{p.title}</h1>
          <div className="mt-8 text-slate-300 leading-relaxed whitespace-pre-line text-[15px]">{p.content}</div>
          <div className="mt-12 bg-navy-800 border border-white/10 rounded-md p-8 text-center">
            <p className="text-white font-bold text-lg">Individuelle Beratung gewünscht?</p>
            <Link to="/termin-buchen" className="mt-4 inline-block bg-gold-500 text-navy-900 font-bold rounded-sm px-6 py-3 hover:bg-gold-300 transition-colors">Kostenloses Erstgespräch</Link>
          </div>
        </div>
      </article>
    </div>
  );
}
